import captureError from '@disco/utils/captureError'

import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import { updateNestedTracks } from '@disco/state-management/actions/NestingActions'
import type { ManageNestingFormState } from '@disco/state-management/reducers/forms/manage-nesting'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
type Props = {
  formState: ManageNestingFormState
  updateForm: (...args: Array<any>) => any
  onClose: (...args: Array<any>) => any
}

const ManageNestingFooterActions = ({
  formState,
  updateForm,
  onClose,
}: Props): React.ReactNode => {
  const dispatch = useDispatch()

  const onSave = async () => {
    try {
      let promises = []

      // TODO: add validation modal if Main track is missing
      if (Object.keys(formState.itemsWithUpdatedFields).length > 0) {
        promises.push(
          dispatch(updateNestedTracks(formState.itemsWithUpdatedFields)),
        )
      }

      if (promises.length > 0) {
        updateForm({
          submitting: true,
        })
        await Promise.all(promises)
      }

      updateForm(
        {
          submitting: false,
        },
        {
          type: 'SAVE_NESTING_FORM',
        },
      )
      onClose()
    } catch (error) {
      captureError(error, { extra: { level: 'info' } })
      updateForm(
        {
          error,
          submitting: false,
        },
        {
          type: 'SAVE_NESTING_FORM',
        },
      )
    }
  }

  return (
    <ButtonContainer alignRight>
      <Button caption="Cancel" onClick={onClose} />
      <Button
        appearance="primary"
        caption="Save"
        onClick={onSave}
        progressCaption="Loading"
        progressIndicator={formState.submitting}
      />
    </ButtonContainer>
  )
}

export default ManageNestingFooterActions
